import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Assignment } from 'shared/api/assignment-service';

export interface AssignmentPanelState {
  isAssignmentPanelOpened: boolean;
  editingAssignment: Assignment | null;
  isAssignmentActionNotificationActive: boolean;
  assignmentActionTimestamp: number | null;
  assignmentActionErrorMessage: string | null;
}

const initialState: AssignmentPanelState = {
  isAssignmentPanelOpened: false,
  editingAssignment: null,
  isAssignmentActionNotificationActive: false,
  assignmentActionTimestamp: null,
  assignmentActionErrorMessage: null,
};

export const assignmentPanelSlice = createSlice({
  name: 'assignmentPanel',
  initialState,
  reducers: {
    setIsAssignmentPanelOpened: (state, action: PayloadAction<boolean>) => {
      state.isAssignmentPanelOpened = action.payload;
    },
    setEditingAssignment: (state, action: PayloadAction<Assignment | null>) => {
      state.editingAssignment = action.payload;
    },
    setIsAssignmentActionNotificationActive: (
      state,
      action: PayloadAction<boolean>,
    ) => {
      state.isAssignmentActionNotificationActive = action.payload;
    },
    setAssignmentActionTimestamp: (
      state,
      action: PayloadAction<number | null>,
    ) => {
      state.assignmentActionTimestamp = action.payload;
    },
    setAssignmentActionErrorMessage: (
      state,
      action: PayloadAction<string | null>,
    ) => {
      state.assignmentActionErrorMessage = action.payload;
    },
  },
});

export const {
  setIsAssignmentPanelOpened,
  setEditingAssignment,
  setIsAssignmentActionNotificationActive,
  setAssignmentActionTimestamp,
  setAssignmentActionErrorMessage,
} = assignmentPanelSlice.actions;

export const assignmentPanelReducer = assignmentPanelSlice.reducer;
